"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentType = exports.ShipmentServiceType = exports.ShipmentServiceLevel = exports.ShipmentStatus = void 0;
var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus["Unallocated"] = "Unallocated";
    ShipmentStatus["FindingDriver"] = "FindingDriver";
    ShipmentStatus["DriverAllocated"] = "DriverAllocated";
    ShipmentStatus["EnrouteToPickup"] = "EnrouteToPickup";
    ShipmentStatus["ArrivedAtPickup"] = "ArrivedAtPickup";
    ShipmentStatus["EnrouteToDelivery"] = "EnrouteToDelivery";
    ShipmentStatus["ArrivedAtDelivery"] = "ArrivedAtDelivery";
    ShipmentStatus["Completed"] = "Completed";
    ShipmentStatus["Cancelled"] = "Cancelled";
})(ShipmentStatus = exports.ShipmentStatus || (exports.ShipmentStatus = {}));
var ShipmentServiceLevel;
(function (ShipmentServiceLevel) {
    ShipmentServiceLevel["Standard"] = "Standard";
    ShipmentServiceLevel["Guaranteed"] = "Guaranteed";
    ShipmentServiceLevel["Dedicated"] = "Dedicated";
})(ShipmentServiceLevel = exports.ShipmentServiceLevel || (exports.ShipmentServiceLevel = {}));
var ShipmentServiceType;
(function (ShipmentServiceType) {
    // In-Network
    ShipmentServiceType["NextDay"] = "NextDay";
    ShipmentServiceType["SameDay"] = "SameDay";
    ShipmentServiceType["CustomRate"] = "CustomRate";
    ShipmentServiceType["LimitedAccessRegional"] = "LimitedAccessRegional";
    // Off-Network
    ShipmentServiceType["Lowest"] = "Lowest";
    ShipmentServiceType["BestValue"] = "BestValue";
    ShipmentServiceType["Fastest"] = "Fastest";
    ShipmentServiceType["Flatbed"] = "Flatbed";
    ShipmentServiceType["Reefer"] = "Reefer";
})(ShipmentServiceType = exports.ShipmentServiceType || (exports.ShipmentServiceType = {}));
var ShipmentType;
(function (ShipmentType) {
    ShipmentType["Direct"] = "Direct";
    ShipmentType["Integrated"] = "Integrated";
})(ShipmentType = exports.ShipmentType || (exports.ShipmentType = {}));
//# sourceMappingURL=shipment.js.map